<template>
  <v-container fluid class="pa-0">
    <v-row align="center" class="mb-6">
      <v-col cols="12" md="6">
        <h1 class="text-h4 font-weight-black white--text">
          Reporte de <span class="primary--text">Compras</span>
        </h1>
        <p class="text-subtitle-1 blue-grey--text text--lighten-2">Análisis mensual por sucursal</p>
      </v-col>
      
      <v-col cols="12" md="6" class="d-flex justify-md-end">
        <div style="width: 300px;">
          <div class="caption primary--text font-weight-bold text-uppercase mb-1">Filtrar Sucursal</div>
          <SucursalesVFilter dark />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="isDataReady && chartData.length > 0">
      <v-col v-for="(data, index) in chartData" :key="index" cols="12" md="6" lg="4">
        <v-card flat color="transparent" class="pa-0">
          <div class="d-flex align-center mb-4">
            <v-icon color="primary" class="mr-2">mdi-chart-bar</v-icon>
            <span class="text-h6 font-weight-bold white--text">
              {{ data.nombre_sucursal || 'General' }}
            </span>
          </div>
          
          <v-divider dark class="mb-4" style="opacity: 0.1"></v-divider>
          
          <div style="height: 300px;">
            <bar-chart :chartdata="data.chart" />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else-if="loading">
      <v-col v-for="n in 3" :key="n" cols="12" md="4">
        <v-skeleton-loader dark type="card-heading, image" class="transparent" />
      </v-col>
    </v-row>

    <v-row v-else class="mt-12" align="center" justify="center">
      <v-col cols="12" md="6" class="text-center">
        <v-icon size="80" color="blue-grey darken-2">mdi-store-search</v-icon>
        <h2 class="text-h5 font-weight-bold white--text mt-4">
          Seleccioná una sucursal
        </h2>
        <p class="text-subtitle-1 blue-grey--text text--lighten-2">
          Usá el filtro superior para visualizar el gráfico de compras.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "@/chartjs/bar.chart.vue";
import SucursalesVFilter from "@/components/sucursal/SucursalesVFilter.vue";

export default {
  name: "ReporteCompras",
  components: { BarChart, SucursalesVFilter },
  data() {
    return {
      chartData: [],
      isDataReady: false,
      loading: false,
    };
  },
  methods: {
    async fetchReporte() {
      const sucursal_uuid = this.$route.query.uuid_sucursal;
      if (!sucursal_uuid) return;

      this.loading = true;
      this.isDataReady = false;
      
      try {
        const { data } = await this.axios.get(`/reportes/compras?uuid_sucursal=${sucursal_uuid}`);
        this.chartData = Array.isArray(data) ? data : [data];
        this.isDataReady = true;
      } catch (error) {
        console.error("Error", error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    "$route.query.uuid_sucursal": {
      immediate: true,
      handler(value) {
        if (value) this.fetchReporte();
        else {
          this.chartData = [];
          this.isDataReady = false;
        }
      },
    },
  },
};
</script>